export default {
      id: "i-dzen-circle-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-dzen-circle",
      toString: function () {
        return this.url;
      }
    }